import { useMemo } from "react"
import _ from "lodash"

import { IRecord } from "interfaces"

import { useSponsoredContent } from "../useSponsoredContent"

interface ISponsorContentConfig {
  disable?: boolean
  limit?: number
  frequency?: number
}

interface IUseSponsoredRecommendedDirectory {
  recommendedDirectories: IRecord[]
  recommendedDirectoryConfig: ISponsorContentConfig
}
export const useRecommendedDirectory =
  (): IUseSponsoredRecommendedDirectory => {
    const { recommendedDirectory } = useSponsoredContent()

    const recommendedDirectoryConfig = useMemo(
      () => _.get(recommendedDirectory, "config"),
      [recommendedDirectory]
    )

    const recommendedDirectories = useMemo(
      () => _.get(recommendedDirectory, "data", []),
      [recommendedDirectory]
    )

    return {
      recommendedDirectories,
      recommendedDirectoryConfig,
    }
  }
